var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendSvgrepoCom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0119 35L33 20L8.0119 5L8 16.6667L25.8571 20L8 23.3333L8.0119 35Z",
    fill: "#A2ABE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSvgrepoCom2);
export default __webpack_public_path__ + "static/media/send-svgrepo-com (2).4d93a38ae7b94d89c9690a649907ad8e.svg";
export { ForwardRef as ReactComponent };